const uuidv4 = require('uuid/v4');

export function addDateOrdinal(value) {
  const mod10 = value % 10;
  const mod100 = value % 100;

  let suffix = '';
  if (mod10 === 1 && mod100 !== 11) {
    suffix = 'st';
  } else if (mod10 === 2 && mod100 !== 12) {
    suffix = 'nd';
  } else if (mod10 === 3 && mod100 !== 13) {
    suffix = 'rd';
  } else {
    suffix = 'th';
  }
  return `${value}${suffix}`;
}

export function getBoolean(value) {
  if ((typeof value) === 'string') {
    return value === 'true';
  } else if ((typeof value) === 'boolean') {
    return value;
  }
}

export function capitalize(value) {
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
}

export function dollarFormat(value) {
  return `$${(value / 100).toFixed(2)}`;
}

export function currencyFormat(value, { currencySymbol, decimals } = { currencySymbol: '', decimals: 2 }) {
  return `${currencySymbol}${(value / 100).toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
}

export function generateUUID8Char() {
  return uuidv4().slice(-8);
}

export function getProperSuffix(number, word) {
  return number === 1 ? word : `${word}s`;
}

export function replaceTags(string, tags, replacements) {
  tags.forEach((tag, index) => {
    const expression = new RegExp(tag, 'g');
    // eslint-disable-next-line
    string = string.replace(expression, replacements[index]);
  });

  return string;
}


export default {
  addDateOrdinal,
  getBoolean,
  capitalize,
  dollarFormat,
  currencyFormat,
  generateUUID8Char,
  getProperSuffix,
  replaceTags,
};
